var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15909 0H1.43182C0.644318 0 0.00715925 0.63 0.00715925 1.4L0 12.6C0 13.37 0.637159 14 1.42466 14H10.0227C10.8102 14 11.4545 13.37 11.4545 12.6V4.2L7.15909 0ZM8.59091 11.2H2.86364V9.8H8.59091V11.2ZM8.59091 8.4H2.86364V7H8.59091V8.4ZM6.44318 4.9V1.05L10.3807 4.9H6.44318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.46427ea9ceccd3864eff4eb52c359967.svg";
export { ForwardRef as ReactComponent };